
import defaultLayoutComponent from '~pages/nrw/layouts/NrwDefaultLayoutComponents.js'

import { isEmpty } from 'lodash'

let routeInfo = [
  {
    path: 'member/login',
    name: 'Login',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/Login.vue') }
    ),
    meta: {
      authorized: false,
      title: '로그인'
    }
  },
  {
    path: 'member/find',
    name: 'FindAccount',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/FindAccount.vue') }
    ),
    beforeEnter: (to, from, next) => {
      if (isEmpty(to.query.type)) {
        next(Object.assign({}, to, {query: {type: 'id', step: '1'}}))
        return
      }
      next()
    },
    meta: {
      authorized: false,
      title: '아이디/비밀번호 찾기'
    }
  },
  {
    path: 'member/joinTerms',
    name: 'JoinTerms',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/JoinTerms.vue') }
    ),
    meta: {
      authorized: false,
      title: '회원가입 약관동의'
    }
  },
  {
    path: 'member/join',
    name: 'JoinBasic',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/JoinBasic.vue') }
    ),
    meta: {
      authorized: false,
      title: '회원가입'
    }
  },
  {
    path: 'member/joinComplete',
    name: 'JoinComplete',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/JoinComplete.vue') }
    ),
    meta: {
      authorized: false,
      title: '회원가입'
    }
  },
  {
    path: 'member/joinExist',
    name: 'JoinExist',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/JoinExist.vue') }
    ),
    meta: {
      authorized: false,
      title: '기가입 계정 안내'
    }
  },
  {
    path: 'member/joinSns',
    name: 'JoinSns',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/JoinSns.vue') }
    ),
    meta: {
      authorized: false,
      title: '계정 연동 정보 입력'
    }
  },
  {
    path: 'member/joinSnsNaver',
    name: 'JoinSnsNaver',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/JoinSnsNaver.vue') }
    ),
    meta: {
      authorized: false,
      title: '계정 연동 정보 입력'
    }
  },
  {
    path: 'member/releaseLock',
    name: 'ReleaseLock',
    components: Object.assign({}, defaultLayoutComponent, {
      content: () => import(/* webpackChunkName: "page_member" */'~pages/nrw/member/ReleaseLock.vue') }
    ),
    props: true,
    meta: {
      authorized: false,
      title: '계정 잠금 해제 본인 인증'
    }
  }

]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/nrw/child/memberRouter.js